module.exports = __webpack_public_path__ + "img/2.55f41029.svg";